module.exports = __webpack_public_path__ + "img/202412250101.66d31bdb.png";